export default function getCurrentTableId(editor, block) {
  var _editor$value = editor.value,
      startBlock = _editor$value.startBlock,
      endBlock = _editor$value.endBlock;
  return endBlock && endBlock.getIn(['data', 'tableId']) || startBlock && startBlock.getIn(['data', 'tableId']) || block && block.getIn(['data', 'tableId']) || undefined;
}